import axios from 'axios';
import Configs from '../config/Configs';
import { ApiResponse } from '../types/ContentsInterface';
import { getPublicImage } from '../utils/imageUtils';
import { FallbackMetadata } from '../types/ContentsInterface';

export interface SEOData {
  title: string;
  description: string;
  keywords: string;
  imageUrl: string;
}

export async function fetchSEOData(
  pathname: string,
  slug?: string,
  fallbackMetadata?: FallbackMetadata
): Promise<SEOData> {
  try {
    const params: { [key: string]: string } = {
      'filters[group_name]': Configs.CONTENTS.GROUP_NAME.SEO_DETAILS,
    };

    if (slug) {
      params['filters[name]'] = pathname + slug;
    } else {
      params['filters[name]'] = pathname;
    }

    let metaData;

    try {
      const response = await axios.get<ApiResponse>(`${Configs.API.BASE_URL}/contents/public`, { params });
      const data = response.data;
      const rawMetaData = data?.payload?.[0]?.content || '{}';
      metaData = JSON.parse(rawMetaData);
    } catch (error) {
      console.error('Failed to fetch or parse metadata:', error);
      metaData = {};
    }

    const title = metaData?.meta_title || fallbackMetadata?.title || 'AI For Marketers | gimmefy';
    const description = metaData?.meta_description || fallbackMetadata?.description || 'Default Description';
    const keywords = metaData?.meta_keywords || fallbackMetadata?.keywords || 'Default Keywords';
    const imageUrl =
      getPublicImage('frontend-files', metaData?.image || fallbackMetadata?.image as string) ||
      'https://gimmefy.ai/server-assets/images/gimmefy-logo.png';

    return {
      title,
      description,
      keywords,
      imageUrl,
    };

  } catch (error) {
    console.error('Failed to fetch metadata:', error);
    const title = fallbackMetadata?.title || 'AI For Marketers | gimmefy';
    const description = fallbackMetadata?.description || 'Welcome to gimmefy';
    const keywords = fallbackMetadata?.keywords || 'gimmefy, gimmefy.ai, gimmefy ai, gimmefy ai marketing';
    const imageUrl =
      getPublicImage('frontend-files', fallbackMetadata?.image as string) ||
      'https://gimmefy.ai/server-assets/images/gimmefy-logo.png';

    return {
      title,
      description,
      keywords,
      imageUrl,
    };
  }
}
